import { render, staticRenderFns } from "./SettingsPlatform.vue?vue&type=template&id=248cc77e&"
import script from "./SettingsPlatform.vue?vue&type=script&lang=js&"
export * from "./SettingsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPlatform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports